import type { ApiClient } from "@cfg/api-contract";
import type { Brand } from "@cfg/brand-sdk";
import { createContext, useContext } from "react";
import type { Analytics } from "./analytics.ts";
import type { Auth } from "./auth.ts";
import type { Copy } from "./brand.ts";
import type { RegistryClient } from "./registry.ts";

export interface AppServices {
  brand: Brand;
  copy: Copy;
  registry: RegistryClient;
  api: ApiClient | null;
  auth: Auth;
  analytics: Analytics;
}

export const AppCtx = createContext<AppServices | null>(null);

export function useApp(): AppServices {
  const v = useContext(AppCtx);
  if (!v) throw new Error("AppCtx missing");
  return v;
}
